import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
} from '@angular/core';
import { ErrorComponent } from '../error/error.component';

@Component({
  selector: 'ui-control-field',
  standalone: true,
  imports: [ErrorComponent],
  templateUrl: './control-field.component.html',
  styleUrl: './control-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ControlFieldComponent {
  public readonly label = input('');
  public readonly isRequired = input(false, { transform: booleanAttribute });
  public readonly error = input('');
}
